import React, { Component} from 'react';

export default class Link extends Component {
    render() {
        return (
            <li className="main-menu__single-item">
                <a style={{color: this.props.color}} href={ this.props.src  }>{ this.props.text  }</a>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MenuLinks/Link.js